// Chevron drawn in CSS (inline SVG) so every browser shows the same control.
.a-select
  appearance: none
  -webkit-appearance: none
  cursor: pointer
  padding-right: 38px
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1.5l5 5 5-5' fill='none' stroke='%235b6474' stroke-width='1.6' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")
  background-repeat: no-repeat
  background-position: right 14px center
  background-size: 12px 8px
  &__wrap
    padding-right: 0
    .a-select
      padding-right: 38px
